import { RootState } from './reducers'
import { FetchBankSessionsTransactionsStatus } from './reducers/consumerDataPullSessionReducers/fetchBankSessionsTransactionsReducer'

export const showAnimationSelector = (
	state: RootState,
): boolean | undefined => {
	switch (true) {
		case state.fetchBankSessionsTransactionsState.status ===
			FetchBankSessionsTransactionsStatus.FETCHING:
		case state.closeConsumerDataPullSession.closingConsumerDataPullSession:
			return true

		case state.fetchBankSessionsTransactionsState.status ===
			FetchBankSessionsTransactionsStatus.IDLE:
		case state.fetchBankSessionsTransactionsState.status ===
			FetchBankSessionsTransactionsStatus.FETCH_FAILURE:
		case state.closeConsumerDataPullSession.closeConsumerDataPullSessionError !=
			null:
			return false

		default:
			return undefined
	}
}
